import React from "react";
import { SummaryElement} from "../basic/summary-element.js";
import { BlockquoteElement} from "../basic/blockquote-element.js";
import { ImageSlideshowElement } from "../basic/image-slideshow-element";
import { StoryElement } from "@quintype/components";
import { ImageGalleryLightbox } from "./lightbox/image-gallery-lightbox";
import get from "lodash/get";


const StoryPageCard = props => {
  const cardAlignment = get(props.card, ['metadata','attributes','cardalignment'], '');
  return <div className={`card card--${cardAlignment}`}>
    {props.card['story-elements'].filter(element => element.id !== props.firstVideoElementID).map((element, index) => {
      switch (element.subtype) {
        case 'summary':
          return <div key={index}>
            <SummaryElement element={element} key={element.id} story={props.story}></SummaryElement>
          </div>
          break;
        case 'blockquote':
          return <div key={index}>
            <BlockquoteElement element={element} key={element.id} story={props.story}></BlockquoteElement>
          </div>
          break;
        case 'image-gallery':
          return <div key={index}>
          {element.metadata.type === "gallery" ?
            <ImageGalleryLightbox element={element} key={element.id} story={props.story} cdn={props.cdn} />
            :
            <ImageSlideshowElement element={element} key={element.id} story={props.story} />}
            </div>
          break;
        default:
          return <StoryElement element={element} key={element.id} story={props.story}></StoryElement>
      }
    })}
  </div>
};

export { StoryPageCard };
